import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
    selector: 'eci-template-new-field-popup',
    templateUrl: './template-new-field-popup.component.html',
    styleUrls: ['./template-new-field-popup.component.scss']
})
export class TemplateNewFieldPopupComponent {

    @Input() isRequired: boolean = true;

    dateFormats: any;
    isDateField: boolean = false;

    soFieldName: string;
    marketplaceFieldName: string = undefined;

    fields4Select: string[] = [];

    constructor(
        private dialog: MatDialogRef<TemplateNewFieldPopupComponent>,
        private notifySvc: NotificationService
    ) {
    }

    add(): void {
        if (!this.soFieldName || this.marketplaceFieldName === undefined || this.marketplaceFieldName === '') {
            this.notifySvc.showError('All fields should be filled');
            return undefined;
        }

        this.dialog.close({
            soFieldName: this.soFieldName,
            marketplaceFieldName: this.marketplaceFieldName,
        });
    }
}
